export default __webpack_public_path__ + "static/media/041-tiger.8bdf05df.svg";